export const baseURL = '/estimates';

export const settings = {
  resultsPerPage: 25,
  defaultOrderBy: 'id',
  defaultOrder: 0 // 1=asc 0=desc
};
